import { TextParam } from "modules/preview/schemas/templateSchemas";
import useTemplate from "modules/preview/hooks/useTemplate";

const useTextValue = (textParam: TextParam) => {
  const { data } = useTemplate(false);
  return data?.technical_details[textParam];
};

export default useTextValue;
